export default __webpack_public_path__ + "static/media/git.140fa4d6.png";